import React, { useState, useEffect } from "react";
import PaymentScreen from "./PaymentScreen";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const RechargePlans = ({ mobileNumber, operator, circle, onBack }) => {
    const [rechargePlans, setRechargePlans] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const merchantId = useSelector((state) => state.auth.employeeDetails?.username);
    const { callApi: Browseplan } = useApi("/recharge/indicore/browse-plan", "POST");

    useEffect(() => {
        const fetchRechargePlans = async () => {
            if (!operator || !mobileNumber || !circle) return;

            const cackValue = generateCack();

            setLoading(true);
            setError(null);

            try {
                const browsepayload = {
                    signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
                    cack: cackValue,
                    tel: mobileNumber,
                    operator: operator,
                    type: "rec",
                    circle: circle,
                    merchantId: merchantId

                }
                const response = await Browseplan(browsepayload);

                console.log("responcedataaa", response);
                console.log("responcedataaa", response.data);
                console.log("responcedataaa", response.rdata);
                if (response.rdata?.status === 1) {
                    setRechargePlans(response.rdata);
                    // Set the first category as selected by default
                    const categories = Object.keys(response.rdata).filter(category =>
                        Array.isArray(response.rdata[category])
                    );
                    if (categories.length > 0) setSelectedCategory(categories[0]);
                } else {
                    setError("No recharge plans available.");
                }
            } catch (err) {
                console.error("API Fetch Error:", err);
                setError("Failed to load recharge plans. Please try again.");
            }

            setLoading(false);
        };

        fetchRechargePlans();
    }, [operator, mobileNumber, circle]);


    const generateCack = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    };

    return (
        <div className="w-full">

            <div className="w-full">

                {/* PAYMENT SCREEN */}
                {selectedPlan ? (
                    <div className="p-6">

                        <PaymentScreen
                            mobileNumber={mobileNumber}
                            selectedPlan={selectedPlan}
                            operator={operator}
                            onBack={() => setSelectedPlan(null)}
                        />

                    </div>
                ) : (
                    <>

                        {/* HEADER CARD */}
                        <div className="p-6 mb-4">

                            <h3 className="text-lg font-semibold text-[#1F2A44] mb-4">
                                Recharge Packs
                            </h3>

                            <div className="flex items-center justify-between">

                                <span className="text-sm font-semibold text-gray-700">
                                    +91 {mobileNumber}
                                </span>

                                <button
                                    onClick={onBack}
                                    className="px-4 py-1.5 rounded-lg text-sm bg-[#12345A] text-white"
                                >
                                    Change
                                </button>

                            </div>

                        </div>


                        {/* PLANS CARD */}
                        <div className="p-6">

                            <h3 className="text-lg font-semibold text-[#1F2A44] mb-4">
                                Recharge Plans
                            </h3>

                            {loading && (
                                <p className="text-sm text-gray-500">
                                    Loading plans...
                                </p>
                            )}

                            {error && (
                                <p className="text-sm text-red-500">
                                    {error}
                                </p>
                            )}

                            {!loading && !error && Object.keys(rechargePlans).length > 0 && (
                                <>

                                    {/* CATEGORY TABS */}
                                    <div className="flex gap-2 mb-4 overflow-x-auto">

                                        {Object.keys(rechargePlans)
                                            .filter((cat) => Array.isArray(rechargePlans[cat]))
                                            .map((category, index) => (

                                                <button
                                                    key={index}
                                                    onClick={() => setSelectedCategory(category)}
                                                    className={`px-4 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap
                        ${selectedCategory === category
                                                            ? "bg-[#12345A] text-white"
                                                            : "bg-gray-100 text-gray-700"
                                                        }`}
                                                >
                                                    {category}
                                                </button>

                                            ))}

                                    </div>


                                    {/* PLANS GRID */}
                                    {selectedCategory && (
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[450px] overflow-y-auto pr-1">

                                            {rechargePlans[selectedCategory].map((plan, idx) => (

                                                <div
                                                    key={idx}
                                                    className="
        group cursor-pointer
        border rounded-xl p-4 bg-white
        hover:shadow-lg hover:border-[#12345A]
        transition-all duration-200
        flex flex-col justify-between
        "
                                                >

                                                    {/* PLAN DETAILS */}
                                                    <div>

                                                        <div className="flex items-center justify-between mb-2">

                                                            <span className="text-xl font-bold text-[#12345A]">
                                                                ₹{plan.rs}
                                                            </span>

                                                            <span className="
            text-xs font-medium
            bg-gray-100 text-gray-700
            px-2 py-1 rounded-md
            ">
                                                                {plan.validity}
                                                            </span>

                                                        </div>

                                                        <p className="text-xs text-gray-600 leading-relaxed line-clamp-3">
                                                            {plan.desc}
                                                        </p>

                                                    </div>


                                                    {/* BUY BUTTON */}
                                                    <button
                                                        onClick={() => setSelectedPlan(plan)}
                                                        className="
          mt-4 py-2 rounded-lg text-sm font-semibold
          bg-[#12345A] text-white
          hover:bg-white hover:text-[#12345A]
          border border-[#12345A]
          transition-all
          "
                                                    >
                                                        Buy Plan
                                                    </button>

                                                </div>

                                            ))}

                                        </div>
                                    )}

                                </>
                            )}

                            {!loading && !error && Object.keys(rechargePlans).length === 0 && (
                                <p className="text-sm text-gray-500">
                                    No plans available.
                                </p>
                            )}

                        </div>

                    </>
                )}

            </div>

        </div>
    );
};

export default RechargePlans;
